/**
 * Revertir escrituras anotadas (deshacer persistente) en este dispositivo. La decisión de qué
 * revertir y cuándo hay conflicto es compartida con el servidor (revertPlan).
 */
import { revertPlan } from '@habitos/assistant/domain/records';
import { db } from '../db/db';
import { writeMany, type WriteTrace } from '../db/repo';

export interface RevertResult {
  reverted: number;
  /** Registros que cambiaron después y no se han tocado. */
  conflicts: number;
}

export async function revertWrites(writes: WriteTrace[], now = new Date()): Promise<RevertResult> {
  const rows = new Map<string, Record<string, unknown>>();
  for (const w of writes) {
    const row = (await db.table_(w.entity).get(w.id)) as { data: Record<string, unknown> } | undefined;
    if (row) rows.set(`${w.entity}:${w.id}`, row.data);
  }
  const plan = revertPlan(writes, (entity, id) => rows.get(`${entity}:${id}`), now.toISOString());
  await writeMany(plan.writes);
  return { reverted: plan.writes.length, conflicts: plan.conflicts };
}
